import { FC, useEffect, useState } from 'react';

import { MailOutlined } from '@ant-design/icons';
import { apiErrorHandler } from '@app/services/error.service';
import { notificationService } from '@app/services/notification.service';
import { getSignedBill } from '@FW/api/ECheck/ECheck';
import InputWithLabel from '@FW/components/Inputs/InputWithLabel/InputWithLabel';
import { Button, Collapse, Flex, Input, Typography } from 'antd';
import { t } from 'i18next';
import { Controller, useForm } from 'react-hook-form';

const { Text } = Typography;

type RequestSignedBillProps = {
	checkId: string;
};

export const RequestSignedBill: FC<RequestSignedBillProps> = ({ checkId }) => {
	const [isLoading, setIsLoading] = useState(false);
	const { control, handleSubmit, reset, getValues } = useForm<{
		email: string;
	}>({ defaultValues: {} });

	/**
	 * Reset form fields on unmounting.
	 */
	useEffect(() => () => reset(), []);

	/**
	 * Form submit handler.
	 */
	const handleRequestBill = () => {
		setIsLoading(true);
		const { email } = getValues();

		getSignedBill(checkId, email)
			.then((data) => {
				notificationService.success({
					message: t('transactions.signedBillSucces'),
					description: t('transactions.signedBillSuccesDescription'),
				});
			})
			.finally(() => setIsLoading(false))
			.catch((error) => apiErrorHandler(error));
	};

	return (
		<Collapse
			className='w-full h-max'
			bordered={false}
			items={[
				{
					key: 'email',
					label: <Text className='text-gray'>{t('transactions.signedBillTitle')}</Text>,
					children: (
						<Flex gap={8} className='w-full' align='flex-start'>
							<Controller
								name='email'
								control={control}
								rules={{
									required: t('registrationForm.formErrorMassage'),
									pattern: {
										value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
										message: t('registrationForm.emailValidationError'),
									},
								}}
								render={({ field: { value, onChange }, fieldState: { error } }) => {
									return (
										<InputWithLabel
											id='email'
											error={error && error.message}
											input={
												<Input
													placeholder='Введіть Email'
													status={error && 'error'}
													onChange={onChange}
													value={value}
												/>
											}
										/>
									);
								}}
							/>
							<Button
								loading={isLoading}
								type='primary'
								onClick={handleSubmit(handleRequestBill)}
								icon={<MailOutlined />}>
								Замовити
							</Button>
						</Flex>
					),
				},
			]}
		/>
	);
};
